module.exports = __webpack_public_path__ + "static/media/broken-page-1.a2772bd4.png";